import React from "react";
import AppClass from "../../AppClass";
import toastMessage from "../../components/toastMessage";
import ReminderSettings from "../../components/Loan/admin/LoanReminders/ReminderSettings";
import SavingSettings from "../../components/Loan/admin/SavingSettings/SavingSettings";
import LoanIDSettings from "../../components/Loan/admin/LoanIdSettings/LoanIDSettings";
import LoanProducts from "../../components/Loan/admin/LoanProducts/index";
import GeneralSettings from "../../components/Loan/admin/GeneralSettings/index";
import DualCustody from "./DualCustody";

class Settings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      response: {},
      apps: [],
      exist: false,
      _id: "",
      loan_type: [],
      default_limit_period: "",
      isSubmitting: false,
      setting_id: "",
      fees: {
        insurance: false,
        loanProcessingFee: false,
        loanFormFee: false,
        Others: false,
      },
      errorFee: {},
      customFee: "",
      other: {
        pos: true,
        dashboardPaymentsEnabled: false,
      },
    };
  }

  componentDidMount() {
    const { apps } = this.props;

    let app_options = [];

    for (let el of apps) {
      app_options.push({
        label: el.name,
        value: el._id,
      });
    }

    if (apps.length === 1) {
      this.setState({ appid: apps[0] });
      this.onChangeSacco(apps[0]);
    }

    this.setState({
      apps: app_options,
    });
  }

  onChangeGracePeriod(e, loan_type, i) {
    const type = this.state[loan_type];
    type[i]["grace_period_" + i] = e.target.value;
    this.setState({
      [type]: this.state[loan_type],
    });
  }

  onChangeTerm(e, loan_type, i) {
    const type = this.state[loan_type];
    type[i]["term_" + i] = e.target.value;
    this.setState({
      [type]: this.state[type],
    });
  }

  onChangeContribution(e, loan_type, i) {
    const type = this.state[loan_type];
    type[i]["contribution_rate_" + i] = e.target.value;
    this.setState({
      [type]: this.state[type],
    });
  }

  onChangeLoanPeriod(e, loan_type, i) {
    const type = this.state[loan_type];
    type[i]["loan_period_" + i] = e.target.value;
    this.setState({
      [type]: this.state[type],
    });
  }

  onChangeMethod(e, loan_type, i) {
    const type = this.state[loan_type];
    type[i]["method_" + i] = e.target.value;
    this.setState({
      [type]: this.state[type],
    });
  }

  onChangeAmountRule(e, loan_type, i) {
    const type = this.state[loan_type];
    type[i]["ruleamount_" + i] = e.target.value;
    this.setState({
      [type]: this.state[type],
    });
  }

  onChangeInterestRate(e, loan_type, i) {
    const type = this.state[loan_type];
    type[i]["interest_rate_" + i] = e.target.value;
    this.setState({
      [type]: this.state[type],
    });
  }

  onChangePaymentDuration(e, loan_type, i) {
    const type = this.state[loan_type];
    type[i]["payment_duration_" + i] = e.target.value;
    this.setState({
      [type]: this.state[type],
    });
  }

  onChangeTerm(e, loan_type, i) {
    const type = this.state[loan_type];
    type[i]["term_" + i] = e.target.value;
    this.setState({
      [type]: this.state[type],
    });
  }

  onChangeLongTermGracePeriod(e, i) {
    const { long_term_purpose } = this.state;
    long_term_purpose[i]["long_term_grace_period_" + i] = e.target.value;
    this.setState({
      long_term_p: "",
    });
  }

  onChangeChargedAmount(e, i) {
    const { short_term_purpose } = this.state;

    short_term_purpose[i]["amount_" + i] = e.target.value;

    this.setState({
      short_term_p: "",
    });
  }

  onChangeLoanType(e) {
    const {
      loan_type,
      short_term_purpose,
      long_term_purpose,
      contribution_rate,
      interest_rate,
    } = this.state;
    if (!loan_type.includes(e.target.value)) {
      loan_type.push(e.target.value);
    } else {
      loan_type.splice(loan_type.indexOf(e.target.value), 1);
    }
    this.setState({
      short_term_purpose: !loan_type.includes("Short-term Loans")
        ? []
        : short_term_purpose,
      long_term_purpose: !loan_type.includes("Long-term Loans")
        ? []
        : long_term_purpose,
      contribution_rate: !loan_type.includes("Long-term Loans")
        ? "0"
        : contribution_rate,
      interest_rate: !loan_type.includes("Long-term Loans")
        ? "0"
        : interest_rate,
      loan_type,
    });
  }

  removePurpose(i, loan_type) {
    console.log({ i, loan_type });

    console.log(this.state[loan_type]);
    // const { short_term_purpose, loan_type, long_term_purpose } = this.state;

    if (this.state[loan_type]) {
      this.state[loan_type].splice(i, 1);

      this.setState({
        // short_term_purpose,
        // long_term_purpose,
        // ["grace_period_" + i]: undefined,
        // ["charged_amount_" + i]: undefined,
        [loan_type]: this.state[loan_type],
      });
    }
  }

  get_setting_by_appid(app_id) {
    let response = {};
    const body = {
      app_ids: [app_id],
      model: "setting",
      tag: "by_appid",
    };
    this.setState({ isSubmitting: true });
    AppClass.get_setting_data(body)
      .then((_data) => {
        if (_data.data.length > 0) {
          let data = _data.data[0];
          let loan_type = [],
            keys = Object.keys(data);

          if (keys.includes("short_term")) {
            loan_type.push("Short-term Loans");
          }

          if (keys.includes("long_term")) {
            loan_type.push("Long-term Loans");
          }

          this.setState({
            short_term_purpose: this.formatSettings(true, data.short_term),
            long_term_purpose: this.formatSettings(true, data.long_term),
            loan_type,
            isSubmitting: false,
            setting_id: data._id,
            fees: data.fees || {},
            other: data.other || {},
          });
        } else {
          this.setState({
            isSubmitting: false,
            exist: false,
          });
        }
      })
      .catch((err) => {
        response.error = "Error, " + err;
        this.setState({
          response,
          isSubmitting: false,
          exist: false,
        });
      });
  }

  onChangeSacco(e) {
    let appid = e;
    this.setState(
      {
        appid,
        short_term_purpose: [],
        long_term_purpose: [],
        default_limit_period: "",
        exist: true,
      },
      () => {
        this.get_setting_by_appid(appid.value);
      }
    );
  }

  formatSettings(firstLoad, settings) {
    return settings.map((el, i) => {
      let finalObject = {};
      Object.keys(el).map((key) => {
        let split_key = key.split("_" + i);

        if (firstLoad) {
          return (finalObject[split_key[0] + "_" + i] = el[key]);
        }

        // if (split_key.length > 1) {
        //   return (finalObject[split_key[0] + "_" + i] = el[key]);
        // }
        return (finalObject[split_key[0]] = el[key]);
      });
      return finalObject;
    });
  }

  onSubmit() {
    this.setState({ isSubmitting: true });

    const { short_term_purpose, long_term_purpose, appid, setting_id, fees } =
      this.state;
    let input_data = {};

    this.setState({ isSubmitting: true });

    input_data = {
      model: "setting",
      available: true,
      app_id: appid.value,
      date: new Date().getTime(),
      short_term: this.formatSettings(false, short_term_purpose),
      long_term: this.formatSettings(false, long_term_purpose),
      fees,
      other: this.state.other || {},
    };

    const errors = AppClass.validate_form(input_data);

    let func_route = "add_setting_data";

    if (setting_id && setting_id !== "") {
      input_data.id = setting_id;
      func_route = "update_setting_data";
    }

    if (Object.keys(errors).length === 0) {
      AppClass[func_route](input_data)
        .then(() => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage("success", "Setting saved successful");
        })
        .catch(() => {
          this.setState({ isSubmitting: false });

          toastMessage("error", "Setting saved has failed");
        });
    } else {
      this.setState({ response: errors, isSubmitting: false });
    }
  }

  onChangeFees(field) {
    let { fees } = this.state;
    let fieldV = fees[field];

    if (fieldV) {
      fees[field] = false;
    } else {
      fees[field] = true;
    }

    this.setState({
      fees,
    });
  }

  onChangeCustomFee(e) {
    let { errorFee } = this.state;

    delete errorFee["customFee"];
    this.setState({
      customFee: e.target.value,
    });
  }

  validateCustomFee() {
    let { errorFee, customFee } = this.state;

    if (customFee === "") {
      errorFee["customFee"] = "This field is mandatory";
    }

    this.setState({ errorFee });
  }

  handleCustomizeFee = async () => {
    await this.validateCustomFee;
    let { customFee, fees, errorFee } = this.state;

    if (Object.keys(errorFee).length === 0) {
      let key = customFee.replaceAll(" ", "_");

      fees[key] = true;

      this.setState({ fees, customFee: "" });
    }
  };

  handleRemoveFee(field) {
    let { fees } = this.state;

    delete fees[field];

    this.setState({
      fees,
    });
  }

  onChangeMaximumAmount(e, loan_type, i) {
    const type = this.state[loan_type];
    type[i]["maximumamount_" + i] = e.target.value;
    this.setState({
      [type]: this.state[type],
    });
  }

  render() {
    const {
      response,
      exist,
      interest_rate,
      loan_type,
      payment_period,
      apps,
      appid,
      isSubmitting,
      contribution_rate,
      method,
      long_term_purpose,
      short_term_purpose,
      long_term_p,
      short_term_p,
      default_limit_period,
    } = this.state;

    return (
      <div className="content-cont">
        <div
          className="col-md-12"
          style={{ marginBottom: "2rem" }}
        >
          <ul className="nav nav-tabs">
            <li className="active">
              <a href="#loan-products" data-toggle="tab">
                Loan Products
              </a>
            </li>
            <li>
              <a href="#loan-reminders" data-toggle="tab">
                Loan Reminders
              </a>
            </li>
            <li>
              <a href="#savings-settings" data-toggle="tab">
                Savings Settings
              </a>
            </li>
            <li>
              <a href="#loan-id-settings" data-toggle="tab">
                Loan ID Settings
              </a>
            </li>
            <li>
              <a href="#general-settings" data-toggle="tab">
                General Settings
              </a>
            </li>
            <li>
              <a href="#dual-custody" data-toggle="tab">
                Dual Custody
              </a>
            </li>
          </ul>
        </div>
        <div className="tab-content">
          <div className="tab-pane active" id="loan-products">
            <LoanProducts apps={this.state.apps} token={this.props.ztoken}/>
          </div>
          <div className="tab-pane" id="loan-reminders">
            <ReminderSettings apps={this.state.apps}/>
          </div>
          <div className="tab-pane" id="savings-settings">
            <SavingSettings apps={this.state.apps}/>
          </div>
          <div className="tab-pane" id="loan-id-settings">
            <LoanIDSettings apps={this.state.apps}/>
          </div>
          <div className="tab-pane" id="general-settings">
            <GeneralSettings apps={this.state.apps} token={this.props.ztoken}/>
          </div>
          <div className="tab-pane" id="dual-custody">
            <DualCustody apps={this.state.apps} ztoken={this.props.ztoken}/>
          </div>
        </div>
      </div>
    );
  }
}

export default Settings;
